// プロトタイプ画面を「ログイン済みのときだけ」取ってくる。
//
// 以前は public/prototypes/*.html を静的配信していたが、実取引先名・実売上・乗務員実名が
// 入ったまま、ログインを通らずに読める状態だった（2026-08-24 修正）。
// 今は Pages Function がセッションを検証してから HTML を返す。受け取った本文は
// blob URL にして iframe / 別タブに渡す。中身は自己完結 HTML なので blob でも壊れない。

import { authedFetch } from './serverData.js'

const cache = new Map() // slug -> Promise<string(blob URL)>

export function prototypeUrl(slug) {
  if (!cache.has(slug)) cache.set(slug, fetchAsBlobUrl(slug).catch((e) => { cache.delete(slug); throw e }))
  return cache.get(slug)
}

async function fetchAsBlobUrl(slug) {
  const res = await authedFetch(`api/prototype/${encodeURIComponent(slug)}`)
  const html = await res.text()
  return URL.createObjectURL(new Blob([html], { type: 'text/html' }))
}

// 「詳細プロトタイプ ↗」ボタン。href を持たせない（静的URLはもう存在しない）。
export function prototypeOpenButton(slug, label = '詳細プロトタイプ ↗', cls = '') {
  return `<button type="button" class="${cls}" data-prototype="${slug}">${label}</button>`
}

// data-prototype を持つ要素のクリックを1か所で受ける。各ビューに処理を撒かない。
let wired = false
export function wirePrototypeButtons() {
  if (wired) return
  wired = true
  document.addEventListener('click', async (ev) => {
    const btn = ev.target && ev.target.closest ? ev.target.closest('[data-prototype]') : null
    if (!btn) return
    ev.preventDefault()
    const slug = btn.getAttribute('data-prototype')
    const label = btn.textContent
    btn.disabled = true
    btn.textContent = '読み込み中…'
    try {
      window.open(await prototypeUrl(slug), '_blank', 'noopener')
    } catch (e) {
      console.error(e)
      alert(e.message || '読み込みに失敗しました')
    } finally {
      btn.disabled = false
      btn.textContent = label
    }
  })
}
